"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _sideNav = _interopRequireDefault(require("../../components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _api = require("../../api/api");
var _util = _interopRequireDefault(require("../../assets/static/js/utils/util"));
var _relativeTime = require("../../assets/static/js/utils/relativeTime.js");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _default = exports.default = {
  name: 'batchpub',
  components: {
    sideNav: _sideNav.default,
    footNav: _footNav.default
  },
  data: function data() {
    return {
      showTableHeader: false,
      //是否显示表格表头
      textarea: '',
      //粘贴内容
      textareaPlaceholder: '请输入或黏贴货源信息，系统自动识别路线货物名称和电话，车辆需求默认是罐车，如：北京—上海，不锈钢\n北京—广州，乙二醇\n15900000000',
      resolveData: [],
      //智能识别数据
      batchpubData: [],
      //登录发布请求参数
      goodsSources: [],
      //未登录发布请求参数
      rightAdverData: [],
      //右侧广告
      batchpubDialogVisible: false //控制规则弹窗
    };
  },
  computed: {
    //控制发布按钮
    isempty: function isempty() {
      if (this.batchpubData.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    // 智能识别
    toGetResolving: function toGetResolving() {
      if (this.textarea) {
        this.getResolving();
      } else {
        this.$message({
          message: '请输入/粘贴您的货物信息!',
          type: 'error',
          duration: '1500'
        });
        return false;
      }
    },
    getResolving: function () {
      var _getResolving = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, param, _yield$apiGetResolvin, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              param = {
                "text": this.textarea ? this.textarea : ""
              }; // 安徽-黑龙江18850576156成都-北京18850576156
              _context.next = 4;
              return (0, _api.apiGetResolving)(param);
            case 4:
              _yield$apiGetResolvin = _context.sent;
              data = _yield$apiGetResolvin.data;
              if (data.proCode == '200') {
                that.resolveData = data.proData;
                that.resolveData.filter(function (item) {
                  that.batchpubData.push({
                    startLocation: item.fCity,
                    //出发地
                    endLocation: item.tCity,
                    //目的地
                    vehicleType: item.vehicleType,
                    //车辆类型
                    contactPhone: item.phone,
                    //手机号
                    goodsName: item.productName,
                    //货物名称
                    price: item.price,
                    //价格
                    weight: item.weight,
                    //重量
                    productCategory: item.productCategory //货物类型
                  });
                  that.goodsSources.push({
                    goodsName: item.productName,
                    //货物名称
                    sinPrice: item.price,
                    //价格
                    loadVehicle: item.vehicleType,
                    //车辆类型
                    goodsTypeName: item.productCategory,
                    //货物类型
                    startLocation: item.fCity,
                    //出发地 "startLocation":"省/市/区"
                    startProvince: _util.default.getArea(item.fCity).Province.replace(/(\/)/g, ''),
                    startCity: _util.default.getArea(item.fCity).City.replace(/(\/)/g, ''),
                    startDistrict: _util.default.getArea(item.fCity).Country.replace(/(\/)/g, ''),
                    endLocation: item.tCity,
                    //目的地
                    endProvince: _util.default.getArea(item.tCity).Province.replace(/(\/)/g, ''),
                    endCity: _util.default.getArea(item.tCity).City.replace(/(\/)/g, ''),
                    endDistrict: _util.default.getArea(item.tCity).Country.replace(/(\/)/g, ''),
                    contactPhone: item.phone,
                    //手机号
                    contact: item.userNickname,
                    //联系人名称，可不传
                    goodsWeigth: item.weight,
                    //重量
                    transportRemark: "备注，直接用识别接口返回的remark",
                    releaseTime: (0, _relativeTime.formatDate)(new Date().getTime(), 'yyyy-MM-dd hh:mm:ss')
                  });
                });
                this.textarea = '';
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getResolving() {
        return _getResolving.apply(this, arguments);
      }
      return getResolving;
    }(),
    // 删除
    removeData: function removeData(index, rows) {
      var _this = this;
      this.$confirm('此操作将删除该条货源信息, 是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        //确认删除  
        rows.splice(index, 1);
        _this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(function () {
        // 取消删除
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 批量发布
    toRapidRelease: function toRapidRelease() {
      if (this.batchpubData.length > 0) {
        this.confirmPop();
      } else {
        this.$message({
          message: '当前没有要发布的内容！',
          type: 'error',
          duration: '1500'
        });
        return false;
      }
    },
    confirmPop: function confirmPop() {
      var _this2 = this;
      this.$confirm('您还未登录，是否直接发布？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 未登录直接发布
        var tomd5 = (0, _jsMd.default)('holle');
        console.log(tomd5.toUpperCase());
        _this2.getRapidReleaseBusiness();
      }).catch(function () {
        // 登录发布
        _this2.getRapidRelease();
      });
    },
    // 未登录发布口
    getRapidReleaseBusiness: function () {
      var _getRapidReleaseBusiness = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, param, params, currentTime, appKey, version, ticketStr, ticket, paramete, httpRequest, _yield$apiGetRapidRel, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              param = that.goodsSources.length > 0 ? that.goodsSources : [];
              params = {
                "accountName": "13799832852",
                "goodsSources": param
              };
              currentTime = (0, _relativeTime.formatDate)(new Date().getTime(), 'yyyy-MM-dd hh:mm:ss');
              appKey = "13799832852";
              version = "1.0";
              ticketStr = "userName" + appKey + "currentTime" + currentTime + "v1.0";
              ticket = (0, _jsMd.default)(ticketStr);
              paramete = {
                "requestData": JSON.stringify(params),
                "appKey": appKey,
                "ticket": ticket.toUpperCase(),
                "currentTime": currentTime,
                "version": version,
                "method": "ReleaseGoodsSourceService",
                "accountName": "user"
              };
              httpRequest = {
                httpRequest: JSON.stringify(paramete)
              };
              _context2.next = 12;
              return (0, _api.apiGetRapidReleaseBusiness)(httpRequest);
            case 12:
              _yield$apiGetRapidRel = _context2.sent;
              data = _yield$apiGetRapidRel.data;
              if (data.resultCode == '0') {
                that.$message({
                  message: '发布成功!',
                  type: 'success',
                  duration: '1500'
                });
                that.textarea = '';
                that.batchpubData = [];
              } else {
                that.$message({
                  message: data.resultDesc,
                  type: 'error',
                  duration: '1500'
                });
              }
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getRapidReleaseBusiness() {
        return _getRapidReleaseBusiness.apply(this, arguments);
      }
      return getRapidReleaseBusiness;
    }(),
    // 登录发布口
    getRapidRelease: function () {
      var _getRapidRelease = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, param, params, paramete, jsonParamete, _yield$apiGetRapidRel2, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              param = that.batchpubData.length > 0 ? JSON.stringify(that.batchpubData) : [];
              params = {
                "pubList": param,
                "gsTop": false,
                "sourceTypeId": 2
              };
              paramete = {
                "version": "2",
                "fun": "rapidRelease",
                "param": params
              };
              jsonParamete = {
                jsonParamete: JSON.stringify(paramete)
              };
              _context3.next = 7;
              return (0, _api.apiGetRapidRelease)(jsonParamete);
            case 7:
              _yield$apiGetRapidRel2 = _context3.sent;
              data = _yield$apiGetRapidRel2.data;
              if (data.proCode == '200') {
                that.$message({
                  message: '发布成功!',
                  type: 'success',
                  duration: '1500'
                });
                that.textarea = '';
                that.batchpubData = [];
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getRapidRelease() {
        return _getRapidRelease.apply(this, arguments);
      }
      return getRapidRelease;
    }()
  }
};